import React from 'react';
import { useTranslation } from 'react-i18next';
import { AdCards } from '@/components/AdCards/AdCards';
import * as S from '@/components/AdsSection/AdsSection.styles';
import { AdsSectionProps } from '@/components/AdsSection/AdsSection.types';
import { InfiniteLoader } from '@/components/InfiniteLoader/InfiniteLoader';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const AdsSection: React.FC<AdsSectionProps> = ({
  index,
  title,
  hasPaddingTop,
  bannerInList,
  inListDesktopBanner,
  bottomBanner,
  allAdsLinkData,
  onLoadMore,
  ads,
  adsLoading,
  chunkSize,
  listDataStat,
  className,
  isBannerInListAtTheEnd,
  isBannerInListAfterThreeRows,
  dataTestId,
  noPadding = false,
  hasFirstCardPriority,
  transitionSource,
}) => {
  const { t } = useTranslation();
  const { href: allAdsLinkHref, className: allAdsLinkClassName } =
    allAdsLinkData ?? {};

  return (
    <>
      <S.Box
        $noPadding={noPadding}
        $hasPaddingTop={hasPaddingTop}
        className={className}
        data-testid={dataTestId || CommonTestIds.adsSection.section}
      >
        {title && (
          <S.TitleWrapper>
            <S.TitleBox>
              <S.Title
                as="h2"
                $variant="2"
                data-testid={CommonTestIds.adsSection.title}
              >
                {title}
              </S.Title>
              {allAdsLinkData &&
                (adsLoading ? (
                  <SkeletonLoader width={80} height={20} borderRadius={7} />
                ) : (
                  <S.AllAdsLink
                    href={allAdsLinkHref ?? ''}
                    className={allAdsLinkClassName}
                  >
                    {t('common.all')}
                  </S.AllAdsLink>
                ))}
            </S.TitleBox>
          </S.TitleWrapper>
        )}

        <AdCards
          ads={ads}
          isInitialLoading={adsLoading}
          chunkSize={chunkSize}
          listDataStat={listDataStat}
          bannerInList={bannerInList}
          inListDesktopBanner={inListDesktopBanner}
          bottomBanner={bottomBanner}
          isBannerInListAtTheEnd={isBannerInListAtTheEnd}
          isBannerInListAfterThreeRows={isBannerInListAfterThreeRows}
          hasFirstCardPriority={hasFirstCardPriority}
          sectionIndex={index}
          transitionSource={transitionSource}
        />
      </S.Box>

      {onLoadMore && <InfiniteLoader onVisit={onLoadMore} />}
    </>
  );
};
